<template>
    <ion-page>
        <standard-header title="Camera Test" />
        <ion-content :fullscreen="true">
            <ion-card>
                <ion-item>
                    <ion-label>
                        <h3>Picture Demo</h3>
                        <p>Updated: 2020</p>
                    </ion-label>
                </ion-item>

                <ion-card-header>
                    Card Header
                </ion-card-header>
                <ion-card-content>
                    <p>1. Place the product in front of the device</p>
                    <p>2. Tap Scan</p>
                    <ion-img v-if="blob.length > 0" :src="'data:image/png;base64,' + blob" />
                </ion-card-content>
                <ion-footer>
                    <ion-button @click="camera()" expand="block">
                        Take Picture
                    </ion-button>
                </ion-footer>
            </ion-card>
        </ion-content>

    </ion-page>
</template>

<script>
import { IonPage, IonContent } from '@ionic/vue';
import { IonCard, IonCardHeader, IonCardContent, IonLabel, IonItem, IonFooter, IonButton, IonImg } from '@ionic/vue';
import { settings, menu } from 'ionicons/icons';
import StandardHeader from "@/components/StandardHeader.vue";
import { Camera, CameraResultType } from "@capacitor/camera";

export default  {
    name: 'Camera',
    components: {
        StandardHeader, IonContent, IonPage,
        IonCard, IonCardHeader, IonCardContent, IonLabel, IonItem, IonFooter, IonButton, IonImg
    },
    methods: {
        async camera() {
            const image = await Camera.getPhoto({
                resultType: CameraResultType.Base64
            });
            this.blob = image.base64String;
        }
    },
    setup() {
        return {
            settings,
            menu
        }
    },
    data() {
        return {
            blob: ''
        }
    }
}
</script>
